import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Modal, Form, Button, Card, InputGroup } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import { useProfile } from '../contexts/ProfileContext';
import { useEffect } from 'react';
import Alert from './Alert';


const Checkout = ({  show, onHide, planName, isAnnual }) => {
  const profile = useProfile();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedCard, setSelectedCard] = useState('addCard');
  const [functionError, setFunctionError] = useState("");
  
  const cardRef = useRef();
  const expRef = useRef();
  const cvvRef = useRef();

  const pricing = {
	"pro": {
		"monthly": 69,
		"annual": 41 * 12
	},
	"basic": {
		"monthly": 49,
		"annual": 29 * 12
	}
  }




  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
	  let data;
	  if (selectedCard == 'addCard' || selectedCard == 'noCard') {
		data = {
			card: cardRef.current.value,
			exp: expRef.current.value,
			cvv: cvvRef.current.value,
			newPlan: planName,
			newInterval: isAnnual ? "annual" : "monthly"
		}
	  } else {
		data = {
			cardid: selectedCard,
			newPlan: planName,
			newInterval: isAnnual ? "annual" : "monthly"
		}
	  }
	  axios.post("https://api.viralgpt.com/pixel", {
		email: profile.email,
		event: "InitiateCheckout",
		price: isAnnual ? pricing[planName].annual : pricing[planName]?.monthly
	  }, {
		withCredentials: true
	  })

      const response = await axios.post('https://api.viralgpt.com/purchase', data, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });

      if (response.status === 200) {
		axios.post("https://api.viralgpt.com/pixel", {
			email: profile.email,
			event: "Purchase",
			price: isAnnual ? pricing[planName].annual : pricing[planName]?.monthly
		}, {
			withCredentials: true
		})
        setShowSuccess(true);
        onHide();
        
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || err.message || 'Unknown error';
      setFunctionError('Error processing payment: ' + errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  if (showSuccess) {
    return (
      <Modal show={showSuccess} centered>
        <Confetti className="w-full" />
        <Modal.Body className="text-center py-5">
          <i className="fa-solid fa-circle-check text-green-500 text-6xl mb-4"></i>
          <h3 className="text-2xl font-bold mb-2">Purchase Successful!</h3>
		  <button onClick={() => window.location.href = '/dashboard/magnet'} className="btn btn-primary bg-instagram w-full mt-4">
            Close
          </button>
        </Modal.Body>
		
      </Modal>
    );
  }



  return (
   <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-instagram font-bold text-2xl">Checkout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert 
          variant="danger" 
          message={functionError} 
          show={!!functionError} 
          onClose={() => setFunctionError("")} 
        />
        <div className="text-center mb-4">
          <div className="flex flex-col gap-2">
            <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
              <div className="text-left">
                <h4 className="font-bold text-lg capitalize">{planName} Plan</h4>
                <p className="text-gray-600 text-sm">{isAnnual ? "Annual" : "Monthly"} Subscription</p>
              </div>
              <div className="text-right">
                {isAnnual && <span className="text-gray-400 line-through">${pricing[planName].annual * 2}</span>}
                <div className="text-xl font-bold text-instagram">
                  ${isAnnual ? pricing[planName].annual : pricing[planName]?.monthly}
                </div>
              </div>
            </div>
            {isAnnual && (
              <div className="bg-green-50 text-green-600 p-3 rounded flex items-center">
                <i className="fa-solid fa-tag me-2"></i>
                <span className="font-bold">50% OFF Applied!</span>
              </div>
            )}

            <div className="border-t border-b py-3 my-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Subtotal</span>
                <span>${isAnnual ? pricing[planName].annual * 2 : pricing[planName]?.monthly}</span>
              </div>
              {isAnnual && (
                <div className="flex justify-between">
                  <span className="text-gray-600">Discount</span>
                  <span className="text-green-600">-${pricing[planName].annual}</span>
                </div>
              )}
              <div className="flex justify-between font-bold mt-2">
                <span>Total</span>
                <span>${isAnnual ? pricing[planName].annual : pricing[planName]?.monthly}</span>
              </div>
            </div>
          </div>
        </div>

        <Card className="shadow-sm">
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              {/* Card Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Payment Method</Form.Label>

                {/* Existing Cards Dropdown */}
                <div className="mb-3" style={{ maxHeight: "360px", overflowY: "auto" }}>
                  

              
                {Object.entries(profile.cards).map(([id, card]) => (
                  <div 
                    key={id} 
                    className={`saved-card-option p-3 rounded-lg mb-2 hover:border-instagram cursor-pointer transition-all ${selectedCard === id ? 'border-instagram' : 'border-gray-300 border'}`}
                    onClick={() => setSelectedCard(id)}
                  >
                    <Form.Check
                      type="radio" 
                      name="savedCard"
                      id={`card-${id}`}
                      className="d-none"
                      onChange={() => setSelectedCard(id)}
                      checked={selectedCard === id}
                    />
                    <div className="d-flex align-items-center gap-2">
                      <div className="rounded-full bg-instagram/10 p-2">
                        {card.cardnumber.startsWith('4') && <i className="fa-brands fa-cc-visa text-instagram"></i>}
                        {card.cardnumber.startsWith('5') && <i className="fa-brands fa-cc-mastercard text-instagram"></i>}
                        {card.cardnumber.startsWith('3') && <i className="fa-brands fa-cc-amex text-instagram"></i>}
                        {!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && <i className="fa-solid fa-credit-card text-instagram"></i>}
                      </div>
                      <span className="font-medium">
                        •••• {card.cardnumber.slice(-4)} ({card.exp})
                      </span>
                    </div>
                  </div>
                ))}

                <div 
                  className={`saved-card-option p-3 rounded-lg mb-2 hover:border-instagram cursor-pointer transition-all ${selectedCard === 'addCard' ? 'border-instagram' : ''}`}
                  onClick={() => setSelectedCard('addCard')}
                >
                  <Form.Check
                    type="radio"
                    name="savedCard" 
                    id="card-new"
                    className="d-none"
                    onChange={() => setSelectedCard('addCard')}
                    checked={selectedCard === 'addCard'}
                  />
                  <div className="d-flex align-items-center gap-2">
                    <div className="rounded-full bg-instagram/10 p-2">
                      <i className="fa-solid fa-plus text-instagram"></i>
                    </div>
                    <span className="font-medium">
                      Add New Card
                    </span>
                  </div>
                </div>
				

                </div>
              </Form.Group>

              {/* New Card Form */}
			  {(profile.cards.length == 0 || selectedCard == 'addCard') && (
              <div className="new-card-form">
                <InputGroup className="mb-3">
                  <InputGroup.Text>
                    <i className="fa-solid fa-credit-card text-instagram" />
                  </InputGroup.Text>
                  <Form.Control
                    as={InputMask}
                    type="text"
                    ref={cardRef}
                    placeholder="Card Number"
                    mask="9999 9999 9999 9999"
                    maskChar=""
                    required
                  />
                </InputGroup>

                <div className="d-flex gap-3 mb-3">
                  <InputGroup>
                    <InputGroup.Text>
                      <i className="fa-solid fa-calendar text-instagram" />
                    </InputGroup.Text>
                    <Form.Control
                      as={InputMask}
                      maskChar=""
                      type="text"
                      ref={expRef}
                      placeholder="MM/YY"
                      mask="99/99"
                      required
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputGroup.Text>
                      <i className="fa-solid fa-lock text-instagram" />
                    </InputGroup.Text>
                    <Form.Control
                      as={InputMask}
                      maskChar=""
                      type="text"
                      ref={cvvRef}
                      placeholder="CVV"
                      mask="9999"
                      required
                    />
                  </InputGroup>
                </div>
              </div>
			  )}

              <Button
                type="submit"
                variant="primary"
                className="w-100 bg-instagram border-0 hover:bg-instagram/90"
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : `Purchase`}
              </Button>
            </Form>
			<br/>
			<img src="https://bucket-qcmpq1.s3.us-east-2.amazonaws.com/wp-content/uploads/2020/06/29203137/major-credit-card-logos-png-5.png" className="w-1/2 mx-auto">
			</img>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default Checkout;
